import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {Row, Col, Card, Table, Spinner, Modal, Button, ButtonGroup, DropdownButton} from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import Avatar from "../../common/Avatar";
import {item} from "../../../lib/api/entities";
import {_exportPDF} from "../../../lib/api/api";
import {getDocumentStatus} from "../../../lib/api/document";
import {list} from "../../../lib/api/license";
import {currentSeason} from "../../../lib/api/season";
import {List as Players} from './Players';
import CardDropdown from 'components/common/CardDropdown';
import {Dropdown} from 'react-bootstrap';
import {useAppContext} from "../../../providers/AppProvider";
import SubtleBadge from "../../common/SubtleBadge";
import {toast} from "react-toastify";
import SearchLicenseAccordion from "../../common/SearchLicenseAccordion";

export const List = () => {
    const {userApp, refreshNotification} = useAppContext();
    const entities_guide = localStorage.getItem("entities_guide");

    const [search, setSearch] = useState({});
    const [documents, setDocuments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState([]);
    const [mode, setMode] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [license, setLicense] = useState(null);
    const [entities, setEntities] = useState(null);
    const [season, setSeason] = useState({});

    const user =  JSON.parse(localStorage.getItem('user'));

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const paramsObj = Object.fromEntries(queryParams.entries());

    const handleEdit = id => {
      const _license = documents.find(c => c.document_guid === id);
      setLicense(_license);
      setMode("edit")
      setShowModal(true);
    };

    const handleView= id => {
        const _license = documents.find(c => c.document_guid === id);
        setLicense(_license);
        setMode("view")
        setShowModal(true);
    };

    const getDocuments = () => {
        list()
            .then((res) => {
                setDocuments(res)
            })
            .catch((err) => console.error(err))
    };

    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                if (userApp.entities_guide) {
                    const rowEntities = await item(userApp.entities_guide);
                    setEntities(rowEntities)
                }
                const rowDoc = await list(search);
                setDocuments(rowDoc)

                const rowStatus = await getDocumentStatus({"document_type_id": 10});
                setStatus(rowStatus);

                const rowSeason = await  currentSeason()
                setSeason(rowSeason[0]);

                setIsLoading(false);
            } catch (error) {

            }
        })();
    }, [userApp, search]);

    const playersToPdf = async (data) => {
        let params = data
        return await _exportPDF(`report/pdf/${data.club_guid}`);
    };

    const stafToPdf = async (data) => {
        return await _exportPDF(`report/pdf-staff/${data.club_guid}`);
    };

    const renderActions = item => (
        <CardDropdown>
            <div className="py-2">
                {item.is_locked ? (
                    <Dropdown.Item onClick={() => handleView(item.document_guid)}>
                        Pregled dokumenta
                    </Dropdown.Item>
                ) : (
                    <Dropdown.Item onClick={() => handleEdit(item.document_guid)}>
                        Dodaj igrača
                    </Dropdown.Item>
                )}
            </div>
        </CardDropdown>
    );

    return (
        <Row className="g-2">
            <SearchLicenseAccordion
                document_type_id={10}
                paramsObj = {paramsObj}
                handleSearch={(data) => {
                    setSearch(data);
                }}
            />
            <Col xs={12}>
                <Card className={classNames('h-100')}>
                    <Card.Header>
                        <Row className={classNames('g-2')}>
                            <Col>
                                <Flex>
                                    <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                                        Licenciranje igrača  <div><h6>{season.name} </h6></div>
                                    </h5>
                                </Flex>
                            </Col>
                            <Col xs="auto">
                                {(user.club_guid ?
                                    <ButtonGroup vertical>
                                        <DropdownButton  variant="primary" as={ButtonGroup} title="Štampa" id="bg-vertical-dropdown-1">
                                            <Dropdown.Item onClick={() => playersToPdf({club_guid: user.club_guid})} eventKey="1">licence za igrače</Dropdown.Item>
                                            <Dropdown.Item onClick={() => stafToPdf({club_guid: user.club_guid})} eventKey="2">licence za trenere</Dropdown.Item>
                                        </DropdownButton>
                                    </ButtonGroup> : ""
                                )}
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body className="bg-body-tertiary">
                        {isLoading ? (<div className="text-center">
                            <Spinner animation="border" role="status"/>
                        </div>) : (<Row className="mb-3">
                            <div className="d-none d-xl-block">
                                <Table responsive>
                                    <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th className="text-start" scope="col">ID</th>
                                        <th scope="col">Naziv klub</th>
                                        <th scope="col">Takmičenje</th>
                                        <th className="text-end" scope="col">Licenciraj</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {documents.map((item, i) => (<tr key={i}>
                                        <td>
                                            <div className="ms-2">
                                                <Avatar
                                                    src={process.env.REACT_APP_BASE_API_URL +`/uploads/${item.image_path}`}
                                                    size="l" name={item.club_name}/>
                                            </div>
                                        </td>
                                        <td className="text-nowrap">
                                            <div className="d-flex align-items-center">
                                                <div className="ms-2">{item.document_id}</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="ms-2">{item.club_name}</div>
                                        </td>
                                        <td>
                                            <div className="ms-2">{item.competitions_name}</div>
                                        </td>
                                        <td className="text-end">{renderActions(item)}</td>
                                    </tr>))}
                                    </tbody>
                                </Table>
                            </div>

                            <div className="d-xl-none">
                                <Row className="g-3">
                                    {documents.map((item, i) => (
                                        <Col xs={12} key={item.document_guid || i}>
                                            <div
                                                className="border rounded-4 bg-white h-100 p-3 shadow-sm"
                                                style={{ borderColor: '#dfe3ee' }}
                                            >
                                                <div className="d-flex align-items-start justify-content-between gap-3">
                                                    <div className="flex-shrink-0">
                                                        <Avatar
                                                            src={process.env.REACT_APP_BASE_API_URL +`/uploads/${item.image_path}`}
                                                            size="2xl"
                                                            name={item.club_name}
                                                        />
                                                    </div>
                                                    <div className="flex-shrink-0">{renderActions(item)}</div>
                                                </div>

                                                <div className="mt-3">
                                                    <div className="fw-semibold text-dark fs-8">
                                                        {item.club_name || '-'}
                                                    </div>

                                                    <div className="d-flex flex-wrap gap-2 mt-2">
                                                        <span className="badge rounded-pill badge-subtle-primary">
                                                            {item.document_id || '-'}
                                                        </span>
                                                    </div>

                                                    <div className="text-700 fs-10 mt-2">
                                                        {item.competitions_name || '-'}
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        </Row>)}
                    </Card.Body>

                    <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>{license?.competitions_name || ''}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Players
                                initialData={license}
                                initMode = {mode}
                                onClose={() => setShowModal(false)}
                                onSave={getDocuments}
                            />
                        </Modal.Body>
                    </Modal>
                </Card>
            </Col>
        </Row>
    );
};

export default List;
